import { render, staticRenderFns } from "./PermisosEnCurso.vue?vue&type=template&id=b5b6df54&"
import script from "./PermisosEnCurso.vue?vue&type=script&lang=js&"
export * from "./PermisosEnCurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports